export default __webpack_public_path__ + "static/N0071-db160db7f69283631ed368f8ac785126.png";